export default "__VITE_ASSET__CVCzMTXi__"